import React from "react";
import styles from "./BannerHeader.module.css";
import diamondRound from "../../assets/diamonds/diamond_round.png";
import diamondPrincess from "../../assets/diamonds/diamond_princess.png";
import diamondOval from "../../assets/diamonds/diamond_oval.png";
import diamondPear from "../../assets/diamonds/diamond_pear.png";
import diamondHeart from "../../assets/diamonds/diamond_heart.png";
import diamondEmerald from "../../assets/diamonds/diamond_emerald.png";

const diamondImages = [
  { src: diamondRound, alt: "Round Diamond" },
  { src: diamondPrincess, alt: "Princess Diamond" },
  { src: diamondOval, alt: "Oval Diamond" },
  { src: diamondPear, alt: "Pear Diamond" },
  { src: diamondHeart, alt: "Heart Diamond" },
  { src: diamondEmerald, alt: "Emerald Diamond" },
];

const BannerHeader = () => (
  <div className={styles.bannerWrapper}>
    <div className={styles.textSection}>
      <h2 className={styles.title}>
        Where Timeless Beauty
        <br /> Meets Modern Craft
      </h2>
      <p className={styles.subtitle}>
        Discover expertly crafted diamonds that blend classic elegance with
        contemporary design.
      </p>
    </div>
    <div className={styles.diamondsSection}>
      {diamondImages.map((img, idx) => (
        <div
          key={idx}
          className={
            idx % 2 === 0 ? styles.diamondCardPink : styles.diamondCardBlue
          }
        >
          <img src={img.src} alt={img.alt} className={styles.diamondImg} />
        </div>
      ))}
    </div>
  </div>
);

export default BannerHeader;
